// extracted by mini-css-extract-plugin
export default {"item":"receipt-item_item__crtak"};